import React, { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import LoginForm from './LoginForm';
import RegisterForm from './RegisterForm';

const AuthPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [isLogin, setIsLogin] = useState(true);

  // Check for redirect query param and store it
  useEffect(() => {
    const redirect = searchParams.get('redirect');
    const mode = searchParams.get('mode');
    
    if (redirect) {
      sessionStorage.setItem('intended_route', redirect);
    }
    
    // If mode=login, show login form (for existing users)
    if (mode === 'login') {
      setIsLogin(true);
    } else if (redirect === '/signup') {
      // If redirect is /signup, default to register form
      setIsLogin(false);
    }
  }, [searchParams]);

  return (
    <div className="min-h-screen bg-neutral-900 flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <Link to="/" className="block">
            <h1 className="text-3xl font-bold text-white mb-2 hover:text-cyan-400 transition-colors duration-200 cursor-pointer">
              The <span className="text-cyan-400">Traders</span>
            </h1>
          </Link>
          <p className="text-gray-400">Algorithmic Trading Platform</p>
        </div>
        
        {isLogin ? (
          <LoginForm onSwitchToRegister={() => setIsLogin(false)} />
        ) : (
          <RegisterForm onSwitchToLogin={() => setIsLogin(true)} />
        )}
        
        <div className="mt-8 text-center">
          <p className="text-xs text-gray-500">
            © 2025 The Traders. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AuthPage;
